import React, { useEffect, useState } from 'react';
import NodeEdit from './NodeEdit';

const JsonApiNodeSwitch = ({ jsonApiLang }) => {
  const [bundle, setBundle] = useState();

  useEffect(() => {
    const _bundle = window.location.pathname.split('/').slice(-2)[0];
    setBundle(_bundle);
  }, [window.location.pathname]);

  if (!bundle || !jsonApiLang) return <></>;

  return <NodeEdit jsonApiLang={jsonApiLang} bundle={bundle} />;
};

export default JsonApiNodeSwitch;
